import { make } from 'vuex-pathify';

const state = {
  tableStack: [],
};

const mutations = make.mutations(state);

export default {
  namespaced: true,
  state,
  mutations,
};
